module.exports = __webpack_public_path__ + "static/media/3DPPA36.19b8d2e9.jpg";